export const HEADERS = {
    yard : "Yard",
    yard_code:"Yard Code",
    latitude : "Checkpoint Latitude",
    longitude : "Checkpoint Longitude",
    radius : "Checkpoint Radius",
    city :"City",
    created_by : "Created By" ,
    created_on : "Created On" ,
    modified_by : "Modified By",
    modified_on : "Modified On" ,
    actions : "Edit/Delete"
}
export const TITLES = {
    main_title : "Yard",
    add_title : "Add Yard",
    edit_title : "Edit Yard"
}
export const LABELS = {
    yard_code : "Yard Code",
    yard : "Yard Name",
    checkpoint_latitude : "Checkpoint Latitude",
    checkpoint_longitude : "Checkpoint Longitude",
    checkpoint_radius : "Checkpoint Radius (Km)",
    city : "City"
}
export const PLACE_HOLDERS = {
    yard_code : "Enter Yard Code",
    yard : "Enter Yard Name",
    checkpoint_latitude : "Enter Checkpoint Latitude",
    checkpoint_longitude : "Enter Checkpoint Longitude",
    checkpoint_radius : "Enter Checkpoint Radius",
    city : "Select City"
}
export const BUTTONS = {
    submit : "Submit",
    cancel : "Cancel"
}